import Dashboard from "layouts/dashboard";
import ViewPaySlips from "components/HRMS/HRMS/ViewPaySlips";
import PaySlips from "components/HRMS/HRMS/PaySlips";
import MonthEnd from "components/Forms/BusinessEntry/MonthEnd";
import BankerMaster from "components/Forms/BusinessMasters/BankerMaster";
import DsaMaster from "components/Forms/BusinessMasters/DsaMaster";
import CompanyConfiguration from "components/Forms/Masters/CompanyConfiguration";
import EmployeeMaster from "components/Forms/Masters/EmployeeMaster";
import AccountHeadCreation from "components/Accounts/Masters/AccountHeadCreation";
import GroupCreation from "components/Accounts/Masters/GroupCreation";
import AccountsPayable from "components/Accounts/Reports/AccountsPayable";
import Ledger from "components/Accounts/Reports/Ledger";
import ContraVoucher from "components/Accounts/VoucherEntry/ContraVoucher";
import JurnalVoucher from "components/Accounts/VoucherEntry/JournalVoucher";
import PaymentVoucher from "components/Accounts/VoucherEntry/PaymentVoucher";
import RecieptVoucher from "components/Accounts/VoucherEntry/ReceiptVoucher";
import EmployeeProfitability from "components/Accounts/MISReports/EmployeeProfitability";
import MonthlyDSABusiness from "components/Accounts/MISReports/MonthlyDsaBusiness";
import MonthlyEmployeeBusiness from "components/Accounts/MISReports/MonthlyEmployeeBusiness";
import AccountsReceivable from "components/Accounts/Reports/AccountsReceivable";
import AccessControl from "components/Forms/Masters/AccessControl";
import DataDock from "components/DataDock";
import Icon from "@mui/material/Icon";
import TimeTrack from "components/HRMS/HRMS/TimeTrack";
import MonthlyMIS from "components/Accounts/MISReports/MonthlyMIS";
import ProviderWiseBusiness from "components/Accounts/MISReports/ProviderBusiness";
import ConnectorWiseBusiness from "components/Accounts/MISReports/ConnectorBusiness";
import ProductWiseBusiness from "components/Accounts/MISReports/ProductBusiness";
import MISReport from "components/MISReport";
import CombinedApprovalForm from "components/Forms/Business Approval";
import DsaInvoice from "components/DsaInvoice";
import LandingDashboard from "components/LandingPage";
import BusinessEntry from "components/Forms/BusinessEntry";
import EmployeeMasterHrms from "components/HRMS/HRMS/EmployeeMasterHrms";
import EmployeeAttendence from "components/HRMS/HRMS/EmployeeAttendence";
import Applicant from "components/HRMS/HRMS/Applicant";
import EmployeeLeave from "components/HRMS/HRMS/EmployeeLeave";
import AddEmployeeToPayroll from "components/HRMS/HRMS/AddEmployeeToPayroll";
import SalaryAdvance from "components/HRMS/HRMS/SalaryAdvance";
import PayStructureConfiguration from "components/HRMS/HRMS/PayStructureConfiguration";
import PayStructureMappingToEmployee from "components/HRMS/HRMS/PayStructureMappingToEmployee";
import ApproveSalaryAdvance from "components/HRMS/HRMS/ApproveSalaryAdvance";
import ApproveLeaves from "components/HRMS/HRMS/ApproveLeaves";
import RunPayroll from "components/HRMS/HRMS/RunPayroll";
import MISReview from "components/HeadOffice/MISReview";
import DSAInvoiceReview from "components/HeadOffice/DSAInvoiceReview";
import DSAInvoicePayment from "components/HeadOffice/DSAInvoicePayment";
import SpotPayment from "components/HeadOffice/SpotPayment";
import TotalExpenditureStatement from "components/HeadOffice/TotalExpenditureStatement";
import TotalIncomeStatement from "components/HeadOffice/TotalIncomeStatement";
import HeadOfficeInvoice from "components/HeadOffice/HeadOfficenvoice";
import RoleAssignment from "components/Forms/Masters/MenuMapping";
import ConnectorPayment from "components/HeadOffice/ConnectorPayment";
import EmployeeLetterDesk from "components/EmployeeLetterDesk";
import MonthlyBusinessByDsa from "components/Accounts/MISReports/MonthlyBusinessByDsa";
import ConnectorWiseBusinesByDsa from "components/Accounts/MISReports/ConnectorBusinessByDsa";
import ProductWiseBusinesByDsa from "components/Accounts/MISReports/ProductWiseByDsaId";
import ProviderBusinessByDsa from "components/Accounts/MISReports/ProviderBussinessByDsa";
import DsaMonthEnd from "components/Forms/BusinessEntry/MonthEnd/dsaMonthEnd";
import Registraction from "components/HRMS/HRMS/Registraction";
import DailyTrack from "components/HRMS/HRMS/DailyTrack";
import InsuranceEntry from "components/Forms/BusinessEntry/Insurance/insuranceEntry";
import InsurancePayment from "components/Forms/BusinessEntry/Insurance/insurancePayment";
import InsurancePayout from "components/Forms/BusinessEntry/Insurance/insurancePayout";
import PipeLine from "components/Forms/BusinessEntry/PipeLine";
import HRDocuments from "components/HRMS/HRMS/HRDocuments";
// import InsuranceEntry from "components/Forms/BusinessEntry/insuranceEntry";
// import Agents from "components/HRMS/HRMS/Agents";
const routes = [
  //   {
  //     type: "collapse",
  //     name: "Role Based Access",
  //     key: "role-based-access",
  //     route: "/role-based-access",
  //     icon: <Icon fontSize="small">admin_panel_settings</Icon>,
  //     component: <RoleAssignment />,
  //   },
  //   {
  //     type: "collapse",
  //     name: "Dashboard",
  //     key: "dashboard",
  //     icon: <Icon fontSize="small">dashboard</Icon>,
  //     route: "/dashboard",
  //     component: <Dashboard />,
  //   },
  //   {
  //     type: "collapse",
  //     name: "MIS",
  //     key: "mis-management",
  //     route: "/MIS",
  //     icon: <Icon fontSize="small">assessment</Icon>,
  //     component: <MISReport />,
  //   },
  //   {
  //     type: "collapse",
  //     name: "Employee Letter Desk",
  //     key: "employee letter desk",
  //     route: "/HRMS/employee-letter-desk",
  //     icon: <Icon fontSize="small">mark_email_read</Icon>,
  //     component: <EmployeeLetterDesk />,
  //   },
  //   {
  //     type: "dropdown",
  //     name: "Head Office",
  //     key: "Head Office",
  //     icon: <Icon fontSize="small">corporate_fare</Icon>,
  //     collapse: [
  //       {
  //         type: "collapse",
  //         name: "Head Office",
  //         key: "head-office",
  //         collapse: [
  //           {
  //             type: "collapse",
  //             name: "MIS Review",
  //             key: "MIS-review",
  //             route: "/forms/MIS-review",
  //             icon: <Icon fontSize="small">assessment</Icon>,
  //             component: <MISReview />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "DSA Invoice Review",
  //             key: "dsa-invoice-review",
  //             route: "/forms/DSA-invoice-review",
  //             icon: <Icon fontSize="small">receipt_long</Icon>,
  //             component: <DSAInvoiceReview />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "DSA Invoice Payment",
  //             key: "dsa-invoice-payment",
  //             route: "/forms/DSA-invoice-payment",
  //             icon: <Icon fontSize="small">request_quote</Icon>,
  //             component: <DSAInvoicePayment />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "Head Office Invoice",
  //             key: "head-office-invoice-creation",
  //             route: "/forms/head-office-invoice-creation",
  //             icon: <Icon fontSize="small">note_add</Icon>,
  //             component: <HeadOfficeInvoice />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "Spot Payment",
  //             key: "spot-payment",
  //             route: "/forms/spot-payment",
  //             icon: <Icon fontSize="small">payment</Icon>,
  //             component: <SpotPayment />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "Connector Payment",
  //             key: "connector-payment",
  //             route: "forms/connector-payment",
  //             icon: <Icon fontSize="small">payment</Icon>,
  //             component: <SpotPayment />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "Total Expenditure Statement",
  //             key: "total-expenditure-statement",
  //             route: "/forms/total-expenditure-statement",
  //             icon: <Icon fontSize="small">trending_down</Icon>,
  //             component: <TotalExpenditureStatement />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "Total Income Statement",
  //             key: "total-income-statement",
  //             route: "/forms/total-income-statement",
  //             icon: <Icon fontSize="small">trending_up</Icon>,
  //             component: <TotalIncomeStatement />,
  //           },
  //         ],
  //       },
  //     ],
  //   },
  //   {
  //     type: "dropdown",
  //     name: "Business Forms",
  //     key: "business-forms",
  //     icon: <Icon fontSize="small">assignment</Icon>,
  //     collapse: [
  //       {
  //         type: "collapse",
  //         name: "Business Management",
  //         key: "business-management",
  //         collapse: [
  //           {
  //             type: "collapse",
  //             name: "Company Configuration",
  //             key: "company-configuration",
  //             route: "/forms/company-configuration",
  //             icon: <Icon fontSize="small">business_center</Icon>,
  //             component: <CompanyConfiguration />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "DSA Management",
  //             key: "dsa-management",
  //             route: "/forms/DSA-management",
  //             icon: <Icon fontSize="small">work</Icon>,
  //             component: <DsaMaster />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "Provider Management",
  //             key: "provider-management",
  //             route: "/forms/provider-management",
  //             icon: <Icon fontSize="small">account_balance</Icon>,
  //             component: <BankerMaster />,
  //           },
  //         ],
  //       },
  //     ],
  //   },
  //   {
  //     type: "collapse",
  //     name: "Business Entry",
  //     key: "business-entry",
  //     route: "/business-entry",
  //     icon: <Icon fontSize="small">checklist</Icon>,
  //     component: <BusinessEntry />,
  //   },
  //   {
  //     type: "collapse",
  //     name: "Business Approvals",
  //     key: "business-disbursals",
  //     route: "/business-disbursals",
  //     icon: <Icon fontSize="small">assignment_turned_in</Icon>,
  //     component: <CombinedApprovalForm />,
  //   },
  //   {
  //     type: "collapse",
  //     name: "DSA Invoices",
  //     key: "dsa-invoices",
  //     route: "/DSA-invoices",
  //     icon: <Icon fontSize="small">request_quote</Icon>,
  //     component: <DsaInvoice />,
  //   },
  //   {
  //     type: "collapse",
  //     name: "Data Management",
  //     key: "data-management",
  //     route: "/data-management",
  //     icon: <Icon fontSize="small">file_upload</Icon>,
  //     component: <DataDock />,
  //   },
  //   {
  //     type: "collapse",
  //     name: "Month-End Processing",
  //     key: "month-end-processing",
  //     route: "/month-end-processing",
  //     icon: <Icon fontSize="small">calendar_month</Icon>,
  //     component: <MonthEnd />,
  //   },
  //   {
  //     type: "dropdown",
  //     name: "Accounts",
  //     key: "accounts",
  //     icon: <Icon fontSize="small">account_balance</Icon>,
  //     collapse: [
  //       {
  //         type: "collapse",
  //         name: "Account Management",
  //         key: "account-management",
  //         collapse: [
  //           {
  //             name: "Group Configuration",
  //             key: "group-configuration",
  //             route: "/accounts/group-configuration",
  //             icon: <Icon fontSize="small">group_work</Icon>,
  //             component: <GroupCreation />,
  //           },
  //           {
  //             name: "Account Head Configuration",
  //             key: "account-head-configuration",
  //             route: "/accounts/account-head-configuration",
  //             icon: <Icon fontSize="small">account_tree</Icon>,
  //             component: <AccountHeadCreation />,
  //           },
  //         ],
  //       },
  //       {
  //         type: "collapse",
  //         name: "Voucher Management",
  //         key: "voucher-management",
  //         collapse: [
  //           {
  //             name: "Payment Voucher",
  //             key: "payment-voucher",
  //             route: "/accounts/payment-voucher",
  //             icon: <Icon fontSize="small">payment</Icon>,
  //             component: <PaymentVoucher />,
  //           },
  //           {
  //             name: "Receipt Voucher",
  //             key: "receipt-voucher",
  //             route: "/accounts/receipt-voucher",
  //             icon: <Icon fontSize="small">receipt</Icon>,
  //             component: <RecieptVoucher />,
  //           },
  //           {
  //             name: "Contra Voucher",
  //             key: "contra-voucher",
  //             route: "/accounts/contra-voucher",
  //             icon: <Icon fontSize="small">swap_horiz</Icon>,
  //             component: <ContraVoucher />,
  //           },
  //           {
  //             name: "Journal Voucher",
  //             key: "journal-voucher",
  //             route: "/accounts/journal-voucher",
  //             icon: <Icon fontSize="small">description</Icon>,
  //             component: <JurnalVoucher />,
  //           },
  //         ],
  //       },
  //       {
  //         type: "collapse",
  //         name: "Financial Reports",
  //         key: "financial-reports",
  //         collapse: [
  //           {
  //             name: "Ledger Report",
  //             key: "ledger-report",
  //             route: "/accounts/ledger-report",
  //             icon: <Icon fontSize="small">account_balance_wallet</Icon>,
  //             component: <Ledger />,
  //           },
  //           {
  //             name: "Accounts Payable",
  //             key: "accounts-payable",
  //             route: "/accounts/accounts-payable",
  //             icon: <Icon fontSize="small">request_quote</Icon>,
  //             component: <AccountsPayable />,
  //           },
  //           {
  //             name: "Accounts Receivable",
  //             key: "accounts-receivable",
  //             route: "/accounts/accounts-receivable",
  //             icon: <Icon fontSize="small">request_quote</Icon>,
  //             component: <AccountsReceivable />,
  //           },
  //         ],
  //       },
  //     ],
  //   },
  //   {
  //     type: "dropdown",
  //     name: "Business Reports",
  //     key: "business-reports",
  //     icon: <Icon fontSize="small">insights</Icon>,
  //     collapse: [
  //       {
  //         type: "collapse",
  //         name: "Reports",
  //         key: "reports",
  //         collapse: [
  //           {
  //             type: "collapse",
  //             name: "Staff Profitability",
  //             key: "/MIS-reports/employee-profitability",
  //             route: "/MIS-reports/employee-profitability",
  //             icon: <Icon fontSize="small">insights</Icon>,
  //             component: <EmployeeProfitability />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "Monthly Performance",
  //             key: "/MIS-reports/monthly-business",
  //             route: "/MIS-reports/monthly-business",
  //             icon: <Icon fontSize="small">insert_chart_outlined</Icon>,
  //             component: <MonthlyMIS />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "Provider Performance",
  //             key: "/MIS-reports/provider-business",
  //             route: "/MIS-reports/provider-business",
  //             icon: <Icon fontSize="small">insert_chart_outlined</Icon>,
  //             component: <ProviderWiseBusiness />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "Product Insights",
  //             key: "/MIS-reports/product-wise-business",
  //             route: "/MIS-reports/product-wise-business",
  //             icon: <Icon fontSize="small">insert_chart_outlined</Icon>,
  //             component: <ProductWiseBusiness />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "Connector Business",
  //             key: "/MIS-reports/connector-business",
  //             route: "/MIS-reports/connector-business",
  //             icon: <Icon fontSize="small">insert_chart_outlined</Icon>,
  //             component: <ConnectorWiseBusiness />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "Monthly Business",
  //             key: "/MIS-reports/monthly-business",
  //             route: "/MIS-reports/monthly-business",
  //             icon: <Icon fontSize="small">groups</Icon>,
  //             component: <MonthlyDSABusiness />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "DSA Business",
  //             key: "/MIS-reports/monthly-dsa-business",
  //             route: "/MIS-reports/monthly-DSA-business",
  //             icon: <Icon fontSize="small">groups</Icon>,
  //             component: <MonthlyBusinessByDsa />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "DSA's Business",
  //             key: "/MIS-reports/monthly-dsa's-business",
  //             route: "/MIS-reports/monthly-DSA's-business",
  //             icon: <Icon fontSize="small">groups</Icon>,
  //             component: <MonthlyDSABusiness />,
  //           },
  //           {
  //             type: "collapse",
  //             name: "Employee Business",
  //             key: "/MIS-reports/monthly-employee-business",
  //             route: "/MIS-reports/monthly-employee-business",
  //             icon: <Icon fontSize="small">work_outline</Icon>,
  //             component: <MonthlyEmployeeBusiness />,
  //           },
  //         ],
  //       },
  //     ],
  //   },

  {
    type: "dropdown",
    name: "HRMS",
    key: "HRMS",
    icon: <Icon fontSize="small">people</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Employee Login",
        key: "Employee Login",
        collapse: [
          {
            name: "Empoyee Registration",
            key: "/EmployeeLogin/EmployeeRegistration",
            route: "/EmployeeLogin/EmployeeRegistration",
            icon: <Icon fontSize="small">arrow_forward</Icon>,
            component: <EmployeeMasterHrms />,
          },

          {
            name: "Applicant",
            key: "/EmployeeLogin/Applicant",
            route: "/EmployeeLogin/Applicant",
            icon: <Icon fontSize="small">arrow_forward</Icon>,
            component: <Applicant />,
          },
          {
            type: "collapse",
            name: "Access Control",
            key: "access-control",
            route: "/forms/access-control",
            icon: <Icon fontSize="small">lock</Icon>,
            component: <AccessControl />,
          },
          {
            name: "Add Emplyee To Payroll",
            key: "/accounts/addemployeetopayroll",
            route: "/accounts/addemployeetopayroll",
            icon: <Icon fontSize="small">receipt</Icon>,
            component: <AddEmployeeToPayroll />,
          },
          {
            name: "Employee Attendance",
            key: "/EmployeeLogin/EmployeeAttendence",
            route: "/EmployeeLogin/EmployeeAttendence",
            icon: <Icon fontSize="small">arrow_forward</Icon>,
            component: <EmployeeAttendence />,
          },
          {
            name: "Apply Leave",
            key: "/EmployeeLogin/ApplyLeaves",
            route: "/EmployeeLogin/ApplyLeaves",
            icon: <Icon fontSize="small">arrow_forward</Icon>,
            component: <EmployeeLeave />,
          },
          {
            name: "View PaySlips",
            key: "/EmployeeLogin/ViewPaySlips",
            route: "/EmployeeLogin/ViewPaySlips",
            icon: <Icon fontSize="small">arrow_forward</Icon>,
            component: <PaySlips />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Employee Salary",
        key: "employee-salary",
        collapse: [
          {
            name: "Salary Advance",
            key: "/HRMS/SalaryAdvance",
            route: "/HRMS/SalaryAdvance",
            icon: <Icon fontSize="small">receipt</Icon>,
            component: <SalaryAdvance />,
          },
          {
            name: "Pay Structure Configuration",
            key: "/accounts/paystructureconfiguration",
            route: "/accounts/pay-structure-configuration",
            icon: <Icon fontSize="small">receipt</Icon>,
            component: <PayStructureConfiguration />,
          },
          {
            name: "Pay Structure Mapping To Employee",
            key: "/accounts/pay-structure-mapping-to-employee",
            route: "/accounts/pay-structure-mapping-to-employee",
            icon: <Icon fontSize="small">receipt</Icon>,
            component: <PayStructureMappingToEmployee />,
          },
          {
            name: "Approve Salary Advance",
            key: "/accounts/approvesalaryadvance",
            route: "/accounts/approve-salary-advance",
            icon: <Icon fontSize="small">receipt</Icon>,
            component: <ApproveSalaryAdvance />,
          },
          {
            name: "Registration",
            key: "/HRMS/registration",
            route: "/HRMS/registration",
            icon: <Icon fontSize="small">receipt</Icon>,
            component: <Registraction />,
          },
          {
            name: "Approve Leaves",
            key: "/accounts/approveleaves",
            route: "/accounts/approveleaves",
            icon: <Icon fontSize="small">receipt</Icon>,
            component: <ApproveLeaves />,
          },
          {
            name: "Payroll",
            key: "/accounts/payroll",
            route: "/accounts/payroll",
            icon: <Icon fontSize="small">receipt</Icon>,
            component: <RunPayroll />,
          },
        ],
      },
    ],
  },
];
const componentMap = {
  // PipeLine,
  // Dashboard,
  // InsurancePayment,
  // InsurancePayout,
  // Agents,
  CompanyConfiguration,
  AccessControl,
  Applicant,
  TimeTrack,
  EmployeeLetterDesk,
  // DsaMaster,
  // BankerMaster,
  // BusinessEntry,
  // CombinedApprovalForm,
  // DsaInvoice,
  // MonthEnd,
  // InsuranceEntry,
  // GroupCreation,
  // AccountHeadCreation,
  // PaymentVoucher,
  // RecieptVoucher,
  // ContraVoucher,
  // JurnalVoucher,
  // EmployeeProfitability,
  // MonthlyBusinessByDsa,
  // MonthlyEmployeeBusiness,
  // DataDock,
  // AccountsPayable,
  // AccountsReceivable,
  EmployeeMasterHrms,
  AddEmployeeToPayroll,
  EmployeeAttendence,
  EmployeeLeave,
  RoleAssignment,
  Registraction,
  DailyTrack,
  // MISReport,
  ViewPaySlips,
  PaySlips,
  SalaryAdvance,
  PayStructureConfiguration,
  PayStructureMappingToEmployee,
  ApproveSalaryAdvance,
  ApproveLeaves,
  RunPayroll,
  HRDocuments,
  // MISReview,
  // DSAInvoiceReview,
  // DSAInvoicePayment,
  // HeadOfficeInvoice,
  // SpotPayment,
  // ConnectorPayment,
  // TotalExpenditureStatement,
  // TotalIncomeStatement,
  // MonthlyDSABusiness,
  // ProviderWiseBusiness,
  // ProductWiseBusiness,
  // ConnectorWiseBusiness,
  // ConnectorWiseBusinesByDsa,
  // ProductWiseBusinesByDsa,
  // ProviderBusinessByDsa,
  // DsaMonthEnd,
  // Ledger,
  // MonthlyMIS,
};
export { componentMap };

export default routes;
